/* eslint-disable camelcase */
import { OidcConfiguration, TokenRenewMode } from '@axa-fr/react-oidc';

export const configurationIdentityServer: OidcConfiguration = {
    client_id: import.meta.env.VITE_APP_OIDC_CLIENT_ID!,
    redirect_uri: `${window.location.origin}/authentication/callback`,
    silent_redirect_uri: `${window.location.origin}/authentication/silent-callback`, // Optional activate silent-signin that use cookies between OIDC server and client javascript to restore the session
    authority_time_cache_wellknowurl_in_second: 60 * 60,
    refresh_time_before_tokens_expiration_in_second: 40,
    // The catalog endpoints are scope-protected (RequireScope), and an access token only carries an
    // audience for a resource whose scope was actually requested here - measured against the DEV
    // login, a token without it comes back with aud: undefined and is rejected by the API. The name
    // lives in the environment rather than in this file because it belongs to the backend's app
    // registration, not to the frontend: set VITE_APP_OIDC_API_SCOPE per environment (dev/test/prod
    // may well differ). Left unset, only the standard OIDC scopes are requested - login still
    // works, calls against protected routes come back 401.
    scope: ['openid', 'profile', 'email', import.meta.env.VITE_APP_OIDC_API_SCOPE]
        .filter((entry) => entry && entry.trim().length > 0)
        .join(' '),
    authority: import.meta.env.VITE_APP_OIDC_AUTHORITY,
    preload_user_info: true,
    token_renew_mode: TokenRenewMode.access_token_or_id_token_invalid
};
